import { RecordInformation } from "./RecordInformation";

export default RecordInformation